import { FC } from 'react';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
import MediaTypes from 'types/MediaTypes';
import Paths from 'types/Paths';
// Components
import { Button } from 'components/Buttons';
import PoweredBy from 'components/PoweredBy';
// i18next
import { useTranslation } from 'react-i18next';
import AppBar from 'components/AppBar';

const WaiverPage:FC = () => {
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();
  
  const quiz:IQuiz = useAppSelector(selectQuiz);

  const handleYesClick = () => {
    let path:Paths = 'countdown';
    let params = {};
    if ( quiz.brandVideo ){
      path = 'media';
      params = { mediaType: MediaTypes.BrandVideo };
    }
    navigateTo(path, params);
  }

  const handleNoClick = () => {
    navigateTo('start');
  }

  return (
    <div className="p-4 flex flex-col" style={{
      minHeight: '100dvh',
      background: quiz.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : ''
    }}>
      {quiz.waiver.showBrandLogo ? (
        <AppBar />
      ) : null}
      <div className="flex-1 flex justify-center items-center">
        <div className="min-w-[75%] flex flex-col items-center bg-gray-200 rounded-lg p-4">
          {quiz.waiver.image ? (
            <div className="mb-4">
              <img className="h-24" src={quiz.waiver.image} alt="QuizWizard" style={{
                filter: 'drop-shadow(0 0 10px rgba(0, 0, 0, 0.7)) drop-shadow(0 0 15px rgba(255, 255, 255, 0.8))'
              }} />
            </div>
          ) : null}
          <p className="text-lg text-center mb-4">{quiz.waiver.text}</p>
          <div className="flex gap-4">
            <Button
              disableShadow
              onClick={handleYesClick}
              className="shadow-neu active:shadow-neu-inner hover:bg-gradient-to-br hover:from-[#ced0d4] hover:to-[#f5f7fb]"
            >{t('buttons.yes')}</Button>
            <Button
              disableShadow
              onClick={handleNoClick}
              className="shadow-neu active:shadow-neu-inner hover:bg-gradient-to-br hover:from-[#ced0d4] hover:to-[#f5f7fb]"
            >{t('buttons.no')}</Button>
          </div>
        </div>
      </div>
      <PoweredBy />
    </div>
  )
}

export default WaiverPage;
